import React from 'react';
import { Modal, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import Header from '../../../hoc/Layout/Header/Header';
import './LoadingSpinner.scss';

const modalStyle = {
	display: 'flex',
	justifyContent: 'center',
	top: '40%',
};

const MODAL_WIDTH = 200; //small cube on the screen

const loadingSpinner = (props) => {
	const appAntIcon = <LoadingOutlined type="info" className="loading-icon" spin />;
	const antIcon = <LoadingOutlined style={{ fontSize: !!props.customSize ? props.customSize : 100 }} spin />;
	return (
		<>
			{props.isApp && (
				<div>
					<Header color="#fff" backgroundColor="#000" showMidImage={true} />
					<Modal
						style={modalStyle}
						footer={null}
						closable={false}
						visible={props.visible}
						keyboard={false}
						width={MODAL_WIDTH}
						wrapClassName="modal-style"
					>
						<Spin tip={props.text} size="large" indicator={appAntIcon} />
					</Modal>
				</div>
			)}

			{!props.isApp && <Spin style={{ color: !!props.color ? props.color : 'white' }} indicator={antIcon} tip={props.text} />}
		</>
	);
};

export default loadingSpinner;
